import { Box, Typography, Button, styled, alpha } from '@mui/material';

const primaryColor = '#5E8E7E';

export const PageWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#f8f9fa',
  minHeight: '100vh',
}));

export const DetailCard = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '12px',
  border: '1px solid #e0e0e0',
  overflow: 'hidden',
  boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
}));

export const CardHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  borderBottom: '1px solid #f0f0f0',
}));

export const PlanInfo = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

export const PlanIconBox = styled(Box)({
  width: '64px',
  height: '64px',
  borderRadius: '12px',
  backgroundColor: '#E8F0FE',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#1967D2',
});

export const StatusBadge = styled(Box)<{ active: boolean }>(({ active }) => ({
  padding: '4px 12px',
  borderRadius: '16px',
  fontSize: '0.75rem',
  fontWeight: 600,
  backgroundColor: active ? alpha('#2E7D32', 0.1) : alpha('#d32f2f', 0.1),
  color: active ? '#2E7D32' : '#d32f2f',
  width: 'fit-content',
  marginTop: '4px',
}));

export const HeaderActions = styled(Box)({
  display: 'flex',
  gap: '12px',
});

export const EditButton = styled(Button)({
  textTransform: 'none',
  backgroundColor: primaryColor,
  color: '#fff',
  padding: '6px 32px',
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: alpha(primaryColor, 0.9),
  }
});

export const Section = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const SectionHeader = styled(Box)(({ theme }) => ({
  backgroundColor: primaryColor,
  color: '#fff',
  padding: theme.spacing(1.2, 2),
  fontSize: '0.95rem',
  fontWeight: 600,
  borderTopLeftRadius: '4px',
  borderTopRightRadius: '4px',
}));

export const SectionContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'grid',
  gridTemplateColumns: 'repeat(12, 1fr)',
  gap: theme.spacing(3),
  backgroundColor: '#fff',
}));

export const DataItem = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const DataLabel = styled(Typography)({
  fontSize: '0.85rem',
  color: '#666',
  fontWeight: 500,
});

export const DataValue = styled(Typography)({
  fontSize: '1rem',
  color: '#1A1C1E',
  fontWeight: 600,
});

export const FeatureGrid = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '12px',
  padding: '24px',
});

export const FeatureBadge = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 16px',
  backgroundColor: '#F5F7F6',
  borderRadius: '8px',
  color: '#1A1C1E',
  fontSize: '0.875rem',
  fontWeight: 500,
  border: '1px solid #E0E0E0',
  '& svg': {
    color: primaryColor,
    fontSize: '18px',
  }
});
